// extracted by mini-css-extract-plugin
export default {"body":"ProjectDetails_body__QJffN","projectTitle":"ProjectDetails_projectTitle__OvyD9","imageText":"ProjectDetails_imageText__Y4CfP","imageIcon":"ProjectDetails_imageIcon__g+Yn5"};